module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [(this.bankClosingBalInludingOverDraftList.length > 0) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive-demo p-datatable-gridlines",
    attrs: {
      "value": _vm.bankClosingBalInludingOverDraftList,
      "rowsPerPageOptions": [100, 500, 1000],
      "rows": 100,
      "filters": _vm.filters,
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.N"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bank Name",
      "field": "name"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Account Number",
      "field": "accountNumber"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Account Type",
      "field": "type"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Branch",
      "field": "branch"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Closing Balance",
      "bodyStyle": "text-align: right",
      "field": "closingBalance"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Dr-Cr",
      "bodyStyle": "text-align: right",
      "field": "drCr"
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77130778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/bankReports/bankClosingBalIncludingOverDraft.vue
// module id = 2326
// module chunks = 0